export default "__VITE_ASSET__DLcOoHYC__"